import React from 'react'; // eslint-disable-line
import constants from '../../constants';
import PreviewModuleBottomMenuItem from './PreviewModuleBottomMenuItem';
import PreviewModuleSideMenuItem from './PreviewModuleSideMenuItem';
import PreviewModuleTileMenuItem from './PreviewModuleTileMenuItem';
import PreviewModuleSideMenuIcon from '../svg/preview/PreviewModuleSideMenuIcon';
import PreviewModuleTileMenuIcon from '../svg/preview/PreviewModuleTileMenuIcon';
import i18n from '../../i18n';
import Profile from '../svg/preview/Profile';
import { applyModulesFilter } from "../../utilities/utils";

class PreviewEnableModules extends React.Component {
    render() {
        let modules = this.props.menuItems && this.props.menuItems.length > 0
            ? this.props.menuItems.filter((item) => { return item.displayOrder > -1; }) : [];
        modules = modules.sort((a, b) => { return a.displayOrder - b.displayOrder; })
        if (modules.length > 5 && this.props.menuStyle === 1) {
            modules = modules.slice(0, 4);
            modules.push({ displayOrder: 5, title: 'More', subType: 'more' });
        }

        // CHECK IN MENU WILL SHOW THE STATIC WITH RESPECT TO this.props.checkin 
        // THIS WILL FILTER THE SAME FORM THE LOOP MENU LIST
        modules = applyModulesFilter(modules);
        return (

            <div className="preview-content preview-content_modules__enable-modules">

                <div className="enable-modules-preview">

                    {this.props.menuStyle === constants.MenuStyle
                        .find((c) => { return c.Name === 'Bottom'; }).Id && (
                        <div className="navigation-preview navigation-preview_bottom">

                            <div className="menu-list bottom-wrap">

                                {modules
                                    .sort((a, b) => {
                                        return a.displayOrder > b.displayOrder;
                                    })
                                    .map((md, i) => {
                                        /* eslint-disable */
                                        return (
                                            <PreviewModuleBottomMenuItem
                                                key={i}
                                                menuItem={md}
                                                active={i === 0}
                                            />
                                        );
                                        /* eslint-enable */
                                    })}
                            </div>

                        </div>
                    )}

                    {this.props.menuStyle === constants.MenuStyle
                        .find((c) => { return c.Name === 'SlideOut'; }).Id
                    && (
                        <div className="navigation-preview navigation-preview_slide-out">

                            <div className="menu-list slide-out-wrap">

                                <div className="welcome-intro">
                                    <Profile activeColor="#cccccc" />
                                    <div className="welcome-actions">
                                        <p
                                            className="welcome"
                                            style={{ color: this.props.primaryText }}
                                        >
                                            {i18n.t('modules.enable.preview.welcome-slide')}
                                        </p>
                                        <p className="action">
                                            {i18n.t('modules.enable.preview.action')}
                                        </p>
                                    </div>
                                </div>
                                {this.props.checkin && (
                                    <div id="discover" className="menu-item tile">
                                        <div className="iconic">
                                            <PreviewModuleSideMenuIcon
                                                actionColor={this.props.actionColor}
                                                moduleType="checkin"
                                                secondaryText={this.props.secondaryText}
                                                primaryText={this.props.primaryText}
                                            />
                                        </div>
                                        <h5 style={{ color: this.props.secondaryText }}>{i18n.t('modules.enable.preview.checkin')}</h5>
                                    </div>
                                )}
                                <div id="discover" className="menu-item tile">
                                    <div className="iconic">
                                        <PreviewModuleSideMenuIcon actionColor={this.props.actionColor} moduleType="messages" secondaryText={this.props.secondaryText} primaryText={this.props.primaryText} />
                                    </div>
                                    <h5 style={{ color: this.props.secondaryText }}>{i18n.t('modules.enable.preview.messages')}</h5>
                                </div>
                                <div className="slide-out-spacer" />
                                {modules
                                    .sort((a, b) => {
                                        return a.displayOrder > b.displayOrder;
                                    })
                                    .map((md, i) => {
                                        /* eslint-disable */
                                        return (
                                            <PreviewModuleSideMenuItem
                                                actionColor={this.props.actionColor}
                                                secondaryText={this.props.secondaryText}
                                                primaryText={this.props.primaryText}
                                                key={i}
                                                menuItem={md}
                                                active={i === 0}
                                            />
                                        );
                                        /* eslint-enable */
                                    })}
                            </div>

                        </div>
                    )}

                    {this.props.menuStyle === constants.MenuStyle
                        .find((c) => { return c.Name === 'Tiled'; }).Id && (
                        <div className="navigation-preview navigation-preview_tiled">
                            <h2 style={{ color: this.props.primaryText }}>
                                {i18n.t('modules.enable.preview.welcome-tiled')}
                            </h2>
                            <h3 style={{ color: this.props.secondaryText }}>
                                {this.props.churchName}
                            </h3>

                            <div className="menu-list tile-wrap">

                                {modules
                                    .sort((a, b) => {
                                        return a.displayOrder > b.displayOrder;
                                    })
                                    .map((md, i) => {
                                        /* eslint-disable */
                                        return (
                                            <PreviewModuleTileMenuItem
                                                actionColor={this.props.actionColor}
                                                primaryText={this.props.primaryText}
                                                key={i}
                                                menuItem={md}
                                                active={i === 0}
                                            />
                                        );
                                        /* eslint-enable */
                                    })}
                                {this.props.checkin && (
                                    <div id="discover" className="menu-item tile">
                                        <div className="iconic">
                                            <PreviewModuleTileMenuIcon
                                                actionColor={this.props.actionColor}
                                                moduleType="checkin"
                                            />
                                        </div>
                                        <h5 style={{ color: this.props.primaryText }}>
                                            {i18n.t('modules.enable.preview.checkin')}
                                        </h5>
                                    </div>
                                )}
                                <div id="discover" className="menu-item tile">
                                    <div className="iconic">
                                        <PreviewModuleTileMenuIcon
                                            actionColor={this.props.actionColor}
                                            moduleType="messages"
                                        />
                                    </div>
                                    <h5 style={{ color: this.props.primaryText }}>
                                        {i18n.t('modules.enable.preview.messages')}
                                    </h5>
                                </div>
                                <div id="discover" className="menu-item tile">
                                    <div className="iconic">
                                        <PreviewModuleTileMenuIcon
                                            actionColor={this.props.actionColor}
                                            moduleType="profile"
                                        />
                                    </div>
                                    <h5 style={{ color: this.props.primaryText }}>
                                        {i18n.t('modules.enable.preview.profile')}
                                    </h5>
                                </div>
                            </div>

                        </div>
                    )}

                </div>
            </div>
        );
    }
}

export default PreviewEnableModules;
